import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { TrendingUp, Security, School } from '@mui/icons-material';

interface WelcomeStepProps {
  onNext: () => void;
}

const features = [
  { icon: <TrendingUp color="primary" sx={{ fontSize: 40 }} />, title: 'Paper Trading', desc: 'Handel mit virtuellem Geld — kein Risiko, echte Kurse' },
  { icon: <Security color="success" sx={{ fontSize: 40 }} />, title: 'Sicher lernen', desc: '5 Auto-Trading-Strategien testen und verstehen' },
  { icon: <School color="secondary" sx={{ fontSize: 40 }} />, title: 'Academy', desc: '12 Lern-Module von Grundlagen bis Fortgeschritten' },
];

const WelcomeStep: React.FC<WelcomeStepProps> = ({ onNext }) => {
  return (
    <Box sx={{ textAlign: 'center', maxWidth: 600, mx: 'auto', py: 4 }}>
      <Typography variant="h4" gutterBottom fontWeight={700}>
        Willkommen bei BTrader
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Lerne Trading mit virtuellem Geld. Keine echten Euros, echte Marktdaten.
        Perfekt für Anfänger.
      </Typography>

      <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', mb: 4, flexWrap: 'wrap' }}>
        {features.map((f, i) => (
          <Box key={i} sx={{ textAlign: 'center', maxWidth: 180 }}>
            {f.icon}
            <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 1 }}>{f.title}</Typography>
            <Typography variant="body2" color="text.secondary">{f.desc}</Typography>
          </Box>
        ))}
      </Box>

      <Button variant="contained" size="large" onClick={onNext} sx={{ px: 6, py: 1.5 }}>
        Los geht's
      </Button>
    </Box>
  );
};

export default WelcomeStep;
